export const SAVE_PROGRESS_SCENARIO_EVALUATION_REQUEST =
    'SCENARIO_EVALUATION_EDIT_SAVE_PROGRESS_SCENARIO_EVALUATION_REQUEST';
export const SAVE_PROGRESS_SCENARIO_EVALUATION_SUCCESS =
    'SCENARIO_EVALUATION_EDIT_SAVE_PROGRESS_SCENARIO_EVALUATION_SUCCESS';
export const SUBMIT_SCENARIO_EVALUATION_REQUEST = 'SCENARIO_EVALUATION_EDIT_SUBMIT_SCENARIO_EVALUATION_REQUEST';
export const SUBMIT_SCENARIO_EVALUATION_SUCCESS = 'SCENARIO_EVALUATION_EDIT_SUBMIT_SCENARIO_EVALUATION_SUCCESS';
export const FETCH_SCENARIO_EVALUATION_REQUEST = 'SCENARIO_EVALUATION_EDIT_FETCH_SCENARIO_EVALUATION_REQUEST';
export const FETCH_SCENARIO_EVALUATION_SUCCESS = 'SCENARIO_EVALUATION_EDIT_FETCH_SCENARIO_EVALUATION_SUCCESS';
export const DISPOSE_STORE = 'SCENARIO_EVALUATION_EDIT_DISPOSE_STORE';
